"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var useStyles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  linkBase: {
    '&:hover': {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    //https://smad.jmu.edu/shen/webtype/lineheight.html
    lineHeight: '1.5em'
  },
  displayAsBlock: {
    display: 'block'
  },
  displayInline: {
    display: 'inline'
  },
  uppercase: {
    textTransform: 'uppercase'
  },
  underline: {
    textDecoration: 'underline'
  },
  // Known general variants
  category: {
    color: theme.palette.secondary.main,
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: '1em'
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 700
  },
  author: {
    color: theme.palette.text.secondary
  },
  authorBold: {
    color: theme.palette.text.primary,
    fontWeight: 700
  },
  default: {
    color: theme.palette.secondary.main
  },
  defaultBold: {
    color: theme.palette.secondary.main,
    fontWeight: 700
  },
  // Known text variant sizes
  small: {
    //TODO: OVERRIDE
    fontSize: theme.typography.pxToRem(12),
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(14)
    }
  },
  medium: {
    //TODO: OVERRIDE
    fontSize: theme.typography.pxToRem(16)
  },
  large: {
    //TODO: OVERRIDE
    fontSize: theme.typography.pxToRem(20)
  },
  'x-large': {
    //TODO: OVERRIDE
    fontSize: theme.typography.pxToRem(26)
  },
  titlePopular: {
    //TODO: OVERRIDE
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.primary.main,
    fontWeight: 700,
    lineHeight: '1em',
    textTransform: 'uppercase'
  }
}), {
  name: 'Link'
});
var _default = exports.default = useStyles;